export interface MyLoanInfoWindow {
  sentry_public_dsn: string;
  sentry_config: object;
  sentry_tags_context: Record<string, string>;
}

export function isMyLoanInfoWindow(w: unknown): w is MyLoanInfoWindow {
  return (w as MyLoanInfoWindow | undefined)?.sentry_public_dsn !== undefined;
}
